import {
  TCheckVerificationNumberParams,
  TLoginParams,
  TLoginResponse,
  TPasswordChangeByLoginIdParams,
  TPasswordChangeByTokenParams,
  TSendVerificationEmailParams,
} from 'types/apis/auth';
import { createService, reissueService } from './config/axios';

export const postAllUserLogin = async (data: TLoginParams) =>
  await createService<TLoginResponse>({
    url: '/all-user/login',
    options: {
      method: 'post',
      data,
    },
  });

export const postAllUserLogout = async () =>
  await createService({
    url: '/all-user/logout',
    options: {
      method: 'post',
    },
  });

export const putTermsOfUseAgree = async () => {
  await createService({
    url: '/all-user/terms-of-use-agree',
    options: {
      method: 'put',
    },
  });
};

export const postSendVerificationEmail = async (
  data: TSendVerificationEmailParams
) => {
  await createService({
    url: '/all-user/send-email',
    options: {
      method: 'post',
      data,
    },
  });
};

export const postCheckVerificationNumber = async (
  data: TCheckVerificationNumberParams
) =>
  await createService({
    url: '/all-user/check/verification-number',
    options: {
      method: 'post',
      data,
    },
  });

export const postPasswordChangeByToken = async (
  data: TPasswordChangeByTokenParams
) =>
  await createService({
    url: '/all-user/password-change/token',
    options: {
      method: 'post',
      data,
    },
  });

export const postPasswordChangeByLoginId = async (
  data: TPasswordChangeByLoginIdParams
) => {
  await createService({
    url: '/all-user/password-change/login-id',
    options: {
      method: 'post',
      data,
    },
  });
};

export const postAccessTokenReissue = async () =>
  await reissueService({
    url: '/all-user/access-token/re-issue',
    options: { method: 'post' },
  });
